import {
  Button,
  Dialog,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography
} from '@mui/material';
import { ETaskStatus } from '../../enums/task-status.enum';
import React from 'react';

const StatusChangePopup = ({ open, toggle, onConfirm }) => {
  const statusList = [
    { label: 'To Do', value: ETaskStatus.TO_DO },
    { label: 'In Progress', value: ETaskStatus.IN_PROGRESS },
    { label: 'On Hold', value: ETaskStatus.ON_HOLD }
  ];

  const [selectedStatus, setSelectedStatus] = React.useState(ETaskStatus.TO_DO);

  const handleStatusChange = (event) => {
    setSelectedStatus(event.target.value);
  };

  const handleConfirm = () => {
    onConfirm(selectedStatus);
  };

  React.useEffect(() => {
    if (open) {
      setSelectedStatus(ETaskStatus.TO_DO);
    }
  }, [open]);

  return (
    <Dialog open={open} maxWidth="md" onClose={toggle}>
      <Grid container direction="column" sx={{ padding: '1rem 2rem' }}>
        <Typography variant="h4" sx={{ marginBottom: '5px'}}>Status Change Request</Typography>

        {/* Radio list to select the status */}
        <RadioGroup value={selectedStatus} onChange={handleStatusChange}>
          {statusList.map((status) => (
            <FormControlLabel
              key={status.value}
              value={status.value}
              control={<Radio />}
              label={status.label}
            />
          ))}
        </RadioGroup>

        {/* Buttons at the bottom, centered */}
        <Grid container justifyContent="center" sx={{ marginTop: '2rem' }}>
          <Button
            onClick={toggle}
            variant="outlined"
            sx={{ marginRight: '1rem' }}
          >
            Cancel
          </Button>
          <Button onClick={handleConfirm} variant="contained">
            OK
          </Button>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default StatusChangePopup;
